export default __webpack_public_path__ + "static/media/anuncio-cash-exito.81450dd3.svg";